var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('LayoutHeader',{class:{ bgOn: !_vm.showScrDown }}),_c('vue-spinner'),_c('transition',{attrs:{"name":"content-change","appear":"","mode":"out-in"}},[_vm._t("default")],2),_c('AboutFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }